module.exports = __webpack_public_path__ + "static/media/settings.3a561171.svg";